export default {
  props: {
    name: String,
    label: String,
    value: String,
    modifier: {
      type: String,
      default: 'default'
    },
    checkedString: String,
    description: String,
    checkedBool: Boolean,
    required: Boolean,
    errorMessage: String
  },
  data () {
    const data = {
      isValid: true,
      inputValue: false,
      isChecked: false,
      publicValue: this.value || true
    }
    if (this.checkedString || this.checkedBool) {
      data.isChecked = true
    }
    return data
  },
  watch: {
    checked () {
      this.isChecked = this.checked
    },
    checkedBool (value) {
      this.isChecked = value
    },
    required (value) {
      if (!value) {
        this.validateInput()
      }
    }
  },
  computed: {
    isOpen () {
      if (!this.isChecked) {
        return 'hidden'
      }
      return 'visible'
    },
    height () {
      if (!this.isChecked) {
        return 0
      }
      return this.$refs['content'].getBoundingClientRect().height + 'px'
    }
  },
  methods: {
    validateInput (options = {}) {
      if (!options.skipError) {
        this.isValid = (
          !this.required ||
          (this.required && this.isChecked)
        )
      }
      return this.isValid
    },
    onChange () {
      this.isChecked = !this.isChecked
      if (this.isChecked) {
        this.inputValue = this.publicValue
      } else {
        this.inputValue = false
      }
      this.$emit('change', {
        name: this.name,
        value: this.inputValue
      })
    }
  },
  template: `
  <div class="checkbox" :class="['checkbox--'+modifier]">
    <div class="checkbox__wrapper">
      <label class="checkbox__label" tabindex="0" :class="[isChecked?'is-active':'', !isValid ? 'is-error': '']">
        <div class="checkbox__icon">
          <input
            class="checkbox__icon-el"
            type="checkbox"
            :name="name"
            :value="value"
            :checked="isChecked"
            @change="onChange" />
            <svg class="checkbox__icon-tick" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 12">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M2.121 6.192A1 1 0 00.707 7.607l2.829 2.828.707.707a1 1 0 001.414 0l.707-.707 7.778-7.778a1 1 0 10-1.414-1.414l-7.071 7.07a1 1 0 01-1.414 0L2.12 6.194z" fill="#fff">
              </path>
            </svg>

            <svg class="checkbox__icon-loading" viewBox="0 0 456.817 456.817">
              <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-loading" x="0" y="0"></use>
            </svg>
          </div>
          <span class="f2 checkbox__label-span" v-html="label"></span>
      </label>
      <div v-if="description" class="checkbox__description" :style="{maxHeight: height, visibility: isOpen}">
        <div class="checkbox__description__entry" ref="content">
            <p>
              <slot></slot>
            </p>
        </div>
      </div>
      <div v-if="errorMessage" class="checkbox__error-message" :class="[!isValid && !this.isChecked ? 'is-error': '']" v-html="errorMessage">
      </div>
    </div>
  </div>
  `
}
